import React from 'react';

import IconClose from '@components/Images/Rebranding/IconClose';
import { deep_research_path } from '@routes';
import { dateInLocalTimezone } from '@utils/dates';

import { VIEW_THREAD } from '../constants';

interface AiThreadListItemProps {
  title: string;
  date?: string;
  threadId?: string;
  onViewThreadClick?: () => void;
  onActionClick: (e: React.MouseEvent) => void;
  actionAriaLabel: string;
  children?: React.ReactNode;
}

const AiThreadListItem: React.FC<AiThreadListItemProps> = ({
  title,
  date,
  threadId,
  onViewThreadClick,
  onActionClick,
  actionAriaLabel,
  children,
}) => {
  return (
    <li className="flex justify-between border-0 border-t border-solid border-grayscale-beige py-12">
      <div>
        <div className="mb-2 break-words text-body-md">{title}</div>
        <div className="text-body-sm text-grayscale-gray">
          {dateInLocalTimezone(date)}
          <span className="px-6">&#8226;</span>
          <a
            className="hover:text-primary-magenta dark:hover:text-primary-pink"
            href={deep_research_path({ threadID: threadId })}
            onClickCapture={onViewThreadClick}
          >
            {VIEW_THREAD}
          </a>
        </div>
      </div>
      <div className="ml-16 flex">
        <button
          type="button"
          aria-label={actionAriaLabel}
          onClick={onActionClick}
          className="flex h-20 w-20 items-center justify-center rounded-full border-0 bg-grayscale-gray p-6 text-white"
        >
          <IconClose className="w-full stroke-2 text-white" />
        </button>
      </div>
      {children}
    </li>
  );
};

export default AiThreadListItem;
